import { render } from "./AddUser.vue?vue&type=template&id=4727dfae&scoped=true&ts=true"
import script from "./AddUser.vue?vue&type=script&lang=ts"
export * from "./AddUser.vue?vue&type=script&lang=ts"

import "./AddUser.vue?vue&type=style&index=0&id=4727dfae&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4727dfae"]])

export default __exports__